const config = {
  serverUrl: "https://app.gountsidis.gr/"
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js